"use strict";

var config = {
  addresses: {
    main: "0x314159265dD8dbb310642f98f50C066173C1259b",
    ropsten: "0x112234455c3a32fd11230c42e7bccd4a84e02010",
    rinkeby: "0xe7410170f87102df0055eb195163a03b7f2bff4a"
  }
};
module.exports = config;